import React from 'react';
import { Input } from 'antd';
import FormItem from '../formItem';
import { Controller } from 'react-hook-form';

const ModelDetailForm = ({
	formProps: {
		control,
		formState: { errors },
	},
}) => {
	return (
		<>
			<FormItem label="Name" error={errors?.name?.message}>
				<Controller
					name="name"
					control={control}
					render={({ field }) => <Input placeholder="Enter your model name" {...field} />}
				/>
			</FormItem>
			<FormItem label="Description" error={errors?.description?.message}>
				<Controller
					name="description"
					control={control}
					defaultValue={''}
					render={({ field }) => (
						<Input.TextArea rows={4} placeholder="Enter your model description " {...field} />
					)}
				/>
			</FormItem>
		</>
	);
};

export default ModelDetailForm;
